import moment from 'moment';

export const shiftLabel = shift => ({
    normal: 'Normal', manha: 'Manhã', tarde: 'Tarde', noite: 'Noite', 'manha-1': 'Manhã-1',
    horario_amamentacao: 'Horário de amamentação',
    horario_amamentacao_tarde: 'Amamentação — tarde',
    horario_amamentacao_manha_tarde: 'Amamentação — manhã e tarde',
    horario_amamentacao_1_tarde: 'Amamentação — manhã-1 e tarde',
}[shift] || shift || 'Não definido');

export const getDayAttendance = (date, { employee, overtime, holidays, vacations, absences, sickLeave, shifts }) => {
    const sameDay = value => moment(value).isSame(date, 'day');
    const dayOvertime = overtime.filter(item => sameDay(item.data));
    const shift = shifts.find(item => sameDay(item.data));
    return {
        overtime: dayOvertime,
        total: dayOvertime.reduce((total, item) => total + Math.round(Number(item.horas_trabalhadas) * 100), 0) / 100,
        holidays: holidays.filter(item => sameDay(item.date)),
        vacations: vacations.filter(item => (item.dias_ferias || '').split(',').some(day => day.trim() && sameDay(day.trim()))),
        absences: absences.filter(item => sameDay(item.dia)),
        sickLeave: sickLeave.filter(item => moment(date).isBetween(item.data_inicio, item.data_fim, 'day', '[]')),
        shift: shift?.turno || employee.turno,
        shiftChanged: Boolean(shift),
    };
};

export const summarizeOvertime = (records, holidays) => {
    const holidayDates = new Set(holidays.map(holiday => moment(holiday.date).format('YYYY-MM-DD')));
    const totals = { totalSemana: 0, totalSabadosFeriados: 0, totalDomingos: 0 };
    records.forEach(record => {
        const date = moment(record.data);
        const hours = Math.round(Number(record.horas_trabalhadas) * 100);
        if (!Number.isFinite(hours)) return;
        if (holidayDates.has(date.format('YYYY-MM-DD')) || date.day() === 6) {
            totals.totalSabadosFeriados += hours;
        } else if (date.day() === 0) {
            totals.totalDomingos += hours;
        } else {
            totals.totalSemana += hours;
        }
    });
    return Object.fromEntries(Object.entries(totals).map(([key, value]) => [key, value / 100]));
};
